import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { PropsWithAs } from "../types";
import { ForwardedRef } from "react";
import { forwardRefWithGeneric } from "../utils";

export interface CardProps {
  hover?: boolean;
  outline?: boolean;
}

const Card = <T extends React.ElementType = "div">(
  { as, ...props }: PropsWithAs<CardProps, T>,
  ref: ForwardedRef<any>
) => {
  const { className, onClick, hover = !!onClick, outline, ...rest } = props;
  const Component = as ?? "div";

  return (
    <Component
      {...rest}
      ref={ref}
      onClick={onClick}
      className={twMerge(
        clsx("bg-white rounded-md text-secondary", {
          "cursor-pointer hover:bg-gray-50 hover:shadow-md transition-[background|shadow] duration-300":
            !!hover,
          "shadow-xs": !outline,
          "border border-slate-300": outline,
        }),
        className
      )}
    />
  );
};

export default forwardRefWithGeneric(Card);
